import styled, {css} from 'styled-components';

import {getColor, ms} from '../../../../styles';
import {Checkbox} from '../../../../uikit/Checkbox';
import {Clickable} from '../../../../uikit/Clickable';
import {platform} from '../../../../utils/platform';

export const Container = styled(Clickable)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-block: ${ms(12)} ${ms(12)};
  border-bottom: ${ms(1)} solid ${getColor('border1')};

  ${() =>
    platform.isNative &&
    css`
      padding-block: ${ms(6)} ${ms(6)};
    `};
`;

export const ChannelCheckbox = styled(Checkbox).attrs({
  size: 20,
})`
  margin-inline-end: ${ms(14)};

  ${() =>
    platform.isWeb &&
    css`
      pointer-events: none;
    `};
`;
